/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/2/13 5:48 下午
 * @version V1.0.1
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 * v1.0.1 将close方法提取出来
 */


const modifyOrder = {
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      const pathList = vm.$store.state.tab.tabs.filter(e => e.path === to.path);
      if (pathList && pathList.length > 0) {
        const tab = pathList[0];
        if (tab.pathUpdate === undefined || (tab && tab.pathUpdate)) {
          await vm.init();
          vm.setDefaultValue();
          vm.$store.commit('tab/clearPathUpdate', tab);
        }
      }
    });
  },
  methods: {
    init() {
    },
    async localInitData() {
    },
    async setDefaultValue() {
      const { data } = await this.qGet(`${this.url}/${this.$route.params.id}`);
      this.order.setValue(data);
    },
    getSubmitData() {
      return this.order.modifyData;
    },
    async goSubmit(needAudit, data) {
      const { code } = await this.qPut({
        url: this.url,
        data
      });

      if (code === 200) {
        this.$message.success('修改成功！');
        this.close(true);
      }
    }
  }
};

export default modifyOrder;
